import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';
import { AuthService } from '../../services/auth.service';
import { Subscription, interval } from 'rxjs';

export interface PendenciaLinha {
  nunota:       number;
  dtneg?:       string;
  nomeCliente:  string;
  vendedor:     string;
  prioridade:   string;
  imediato:     string;
  prefixo?:     string;
  confNome:     string;
  dtEnvio:      string;
  qtdPendentes: number;
  totalItens:   number;
}

@Component({
  selector: 'app-conferencia-pendente',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule, FormsModule],
  templateUrl: './conferencia-pendente.component.html',
  styleUrls: ['./conferencia-pendente.component.css']
})
export class ConferenciaPendenteComponent implements OnInit, OnDestroy {
  @Output() verItens = new EventEmitter<number>();

  pedidos: PendenciaLinha[] = [];
  carregando = false;
  erro       = '';
  codusuAtual = 0;
  /** Visão gerencial (todos os vendedores) — por padrão a tela só mostra as
   *  pendências do vendedor logado (codusuAtual); sem esse toggle, quem
   *  está testando/administrando com um usuário que não é o vendedor do
   *  pedido nunca veria nada aqui, mesmo que o envio tenha funcionado. */
  verTodos = false;

  private sub?: Subscription;
  private autoSub?: Subscription;

  constructor(private gateway: SankhyaGatewayService, private auth: AuthService) {}

  async ngOnInit(): Promise<void> {
    this.codusuAtual = await this.auth.getCodusuNumerico();
    this.buscarPedidos(true);
    this.autoSub = interval(15000).subscribe(() => this.buscarPedidos(false));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.autoSub?.unsubscribe();
  }

  buscarPedidos(exibirLoading = false): void {
    if (exibirLoading) { this.carregando = true; this.erro = ''; }
    if (this.sub && !this.sub.closed) this.sub.unsubscribe();

    const codusu = this.verTodos ? 0 : this.codusuAtual;
    this.sub = this.gateway.buscarPendenciasVendedor(codusu).subscribe({
      next: (res: any) => {
        this.carregando = false;
        if (res?.sucesso) {
          this.erro = '';
          this.pedidos = res.pedidos as PendenciaLinha[];
        } else if (exibirLoading || !this.pedidos.length) {
          this.erro = res?.erro || 'Erro ao carregar pendências.';
        }
      },
      error: () => {
        this.carregando = false;
        if (exibirLoading || !this.pedidos.length)
          this.erro = 'Falha de comunicação com o servidor.';
      }
    });
  }

  abrirItens(pedido: PendenciaLinha): void {
    this.verItens.emit(pedido.nunota);
  }
}
